export function openInNewTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function downloadFile(file: Blob, fileName: string): void {
  const a = document.createElement('a')
  a.href = URL.createObjectURL(file)
  a.download = fileName
  a.click()
}
